import { useGetCXTheme } from '@sanlam-glacier/app-common/components';
import { mapCXThemeToGHubTheme } from './ghub-theme.function';

export const useGetTheme = () => {
  const currentCXTheme = useGetCXTheme();
  const ghubTheme = mapCXThemeToGHubTheme(currentCXTheme);
  return ghubTheme;
};
